import(/* webpackMode: "eager" */ "/vercel/path0/app/profile/page.tsx");
